import { IVisaPrepForm } from '../../../../../../types';
import { isPersonTravellingWith } from '../../../../../../utilities/pages';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasMothersPersonalDetails'
  | 'motherNationality'
  | 'motherSameNationality'
  | 'motherFamilyName'
  | 'motherGivenName'
  | 'motherDob'
  | 'motherPlaceOfBirth'
  | 'motherTravellingWith'
  | 'motherUkVisa'
  | 'motherHasPassport'
  | 'motherPassportNumber'
>;

type Params = Fields & {
  dobError: string;
};

export function getPageStatus({
  hasMothersPersonalDetails,
  motherNationality,
  motherSameNationality,
  motherFamilyName,
  motherGivenName,
  motherDob,
  motherPlaceOfBirth,
  motherTravellingWith,
  motherUkVisa,
  motherHasPassport,
  motherPassportNumber,
  dobError,
}: Params): { complete: boolean } {
  let complete = true;

  if (
    hasMothersPersonalDetails === undefined ||
    (hasMothersPersonalDetails === true &&
      (motherNationality === undefined ||
        motherNationality === '' ||
        motherSameNationality === undefined ||
        motherFamilyName === undefined ||
        motherFamilyName === '' ||
        motherGivenName === undefined ||
        motherGivenName === '' ||
        motherDob === undefined ||
        motherDob === '' ||
        motherPlaceOfBirth === undefined ||
        motherPlaceOfBirth === '' ||
        motherTravellingWith === undefined ||
        motherTravellingWith === '' ||
        (isPersonTravellingWith(motherTravellingWith) &&
          (motherUkVisa === undefined ||
            motherHasPassport === undefined ||
            (motherHasPassport === true && (motherPassportNumber === undefined || motherPassportNumber === '')))) ||
        dobError !== ''))
  ) {
    complete = false;
  }

  return { complete };
}
